import { Input, Select } from "antd";
import { useForm } from "react-hook-form";

import SearchIcon from "common/svg/SearchIcon";

import ActionGroup from "./styled-components/ActionGroup";
import Container from "./styled-components/Container";
import Title from "./styled-components/Title";
import SaveButton from "./styled-components/SaveButton";

import "./css/Input.css";
import "./css/Title.css";
import "./css/Select.css";

const { Option } = Select;

interface CategoryHeaderProps {
  title: string;
  formName?: string;
  showSaveButton?: boolean;
  onSearch?(value: string): void;
  onSelect?(value: number): void;
}

interface FormInput {
  searchQuery: string;
}

function CategoryHeader({
  title,
  formName,
  onSearch,
  onSelect,
}: CategoryHeaderProps) {
  const { handleSubmit, register } = useForm<FormInput>();

  function onSubmit(data: FormInput) {
    if (onSearch) onSearch(data.searchQuery);
  }
  return (
    <Container>
      <Title>{title}</Title>
      <ActionGroup>
        {onSelect && (
          <Select defaultValue={10} onChange={onSelect}>
            <Option value={10}>10</Option>
            <Option value={15}>15</Option>
            <Option value={20}>20</Option>
            <Option value={25}>25</Option>
            <Option value={30}>30</Option>
          </Select>
        )}
        {onSearch && (
          <form onSubmit={handleSubmit(onSubmit)}>
            <Input
              {...register("searchQuery")}
              type="search"
              placeholder="Buscar..."
              suffix={<SearchIcon />}
            />
          </form>
        )}
        {Boolean(formName) && (
          <SaveButton type="submit" form={formName}>
            Guardar
          </SaveButton>
        )}
      </ActionGroup>
    </Container>
  );
}

export default CategoryHeader;
